import Vue from 'vue'
import VueRouter from 'vue-router'
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { Dialog } from 'vant';

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const baseRoutes = [
  {
    path: '/index',
    name: 'index',
    component: () => import('@/views/Home.vue'),
  },
  {
    path: '/',
    name: 'index',
    component: () => import('@/views/Home.vue'),
  },
  {
    path: '/:plat_type/index',
    name: 'index',
    component: () => import('@/views/Index.vue'),
  },
  {
    path: '/:plat_type/index2',
    name: 'index',
    component: () => import('@/views/Index2.vue'),
  },
  {
    path: '/:plat_type/listaccompany',
    name: 'listaccompany',
    component: () => import('@/views/ListAccompany.vue'),
  },
  {
    path: '/:plat_type/listcontinuing',
    name: 'listcontinuing',
    component: () => import('@/views/ListContinuing.vue'),
  },
  {
    path: '/:plat_type/listnational',
    name: 'listnational',
    component: () => import('@/views/ListNational.vue'),
  },
  {
    path: '/:plat_type/listqualification',
    name: 'listqualification',
    component: () => import('@/views/ListQualification.vue'),
  },
  {
    path: '/:plat_type/listspecial',
    name: 'listspecial',
    component: () => import('@/views/ListSpecial.vue'),
  },
  {
    path: '/:plat_type/listsystem',
    name: 'listsystem',
    component: () => import('@/views/ListSystem.vue'),
  },
  {
    path: '/:plat_type/idea',
    name: 'idea',
    component: () => import('@/views/Idea.vue'),
  },
  {
    path: '/:plat_type/ideaDetail',
    name: 'ideaDetail',
    meta: {
      requireAuth: true

    },
    component: () => import('@/views/IdeaDetail.vue'),
  },
  {
    path: '/:plat_type/lesson',
    name: 'lesson',
    component: () => import('@/views/Lesson.vue'),
  },
  {
    path: '/:plat_type/demonstrate',
    name: 'demonstrate',
    component: () => import('@/views/Demonstrate.vue'),
  },
  {
    path: '/:plat_type/cert',
    name: 'cert',
    component: () => import('@/views/Cert.vue'),
  },
  {
    path: '/:plat_type/category',
    name: 'category',
    component: () => import('@/views/Category.vue'),
  },
  {
    path: '/:plat_type/search',
    name: 'search',
    component: () => import('@/views/Search.vue'),
  },
  {
    path: '/:plat_type/searchYingyou',
    name: 'search',
    component: () => import('@/views/SearchYingyou.vue'),
  },
  {
    path: '/:plat_type/hot',
    name: 'hot',
    component: () => import('@/views/HotList.vue'),
  },
  {
    path: '/:plat_type/detail',
    name: 'detail',
    meta: {
      requireAuth: true

    },
    component: () => import('@/views/Detail.vue'),
  },
  {
    path: '/:plat_type/detail2',
    name: 'detail',
    meta: {
      requireAuth: true

    },
    component: () => import('@/views/Detail2.vue'),
  },
  {
    path: '/:plat_type/detailYingyou',
    name: 'detail',
    meta: {
      requireAuth: true

    },
    component: () => import('@/views/DetailYingyou.vue'),
  },
  {
    path: '/:plat_type/player',
    name: 'player',

    component: () => import('@/views/Player.vue'),
  },
  {
    path: '/:plat_type/playerYingyou',
    name: 'playerYingyou',

    component: () => import('@/views/PlayerYingyou.vue'),
  },
  {
    path: '/:plat_type/order',
    name: 'order',
    component: () => import('@/views/Order.vue'),
  },
  {
    path: '/:plat_type/train',
    name: 'train',
    component: () => import('@/views/Train.vue'),
  },
  {
    path: '/:plat_type/live',
    name: 'live',
    component: () => import('@/views/Live.vue'),
  },
  {
    path: '/:plat_type/media',
    name: 'media',
    component: () => import('@/views/Media.vue'),
  },
  {
    path: '/:plat_type/livedetail',
    name: 'livedetail',
    meta: {
      requireAuth: true

    },
    component: () => import('@/views/LiveDetail.vue'),
  }, {
    path: '/:plat_type/login/phone',
    name: 'phone',
    component: () => import('@/views/login/phone.vue'),
  },
  {
    path: '/:plat_type/order/make',
    name: 'orderMake',
    component: () => import('@/views/order/make.vue'),
  },
  {
    path: '/:plat_type/userYingyou/center',
    name: 'userCenter',
    component: () => import('@/views/userYingyou/center.vue'),
  },
  {
    path: '/:plat_type/userYingyou/setting',
    name: 'userSetting',
    component: () => import('@/views/userYingyou/setting.vue'),
  },
  {
    path: '/:plat_type/userYingyou/purchased',
    name: 'userPurchased',
    component: () => import('@/views/userYingyou/purchased.vue'),
  },
  {
    path: '/:plat_type/orderYingyou/orderList',
    name: 'orderList',
    component: () => import('@/views/orderYingyou/orderList.vue'),
  },
  {
    path: '/:plat_type/orderYingyou/orderDetail',
    name: 'orderDetail',
    component: () => import('@/views/orderYingyou/orderDetail.vue'),
  },
  {
    path: '/:plat_type/user/center',
    name: 'userCenter',
    component: () => import('@/views/user/center.vue'),
  },
  {
    path: '/:plat_type/user/mine',
    name: 'userMine',
    component: () => import('@/views/user/mine.vue'),
  },
  {
    path: '/:plat_type/user/setting',
    name: 'userSetting',
    component: () => import('@/views/user/setting.vue'),
  },
  {
    path: '/:plat_type/user/purchased',
    name: 'userPurchased',
    component: () => import('@/views/user/purchased.vue'),
  },
  {
    path: '/:plat_type/examin',
    name: 'examin',
    component: () => import('@/views/Examin.vue'),
  },
  {
    path: '/:plat_type/examinList',
    name: 'examinList',
    component: () => import('@/views/examin/ExaminList.vue'),
  },
  {
    path: '/:plat_type/examinResult',
    name: 'examinResult',
    component: () => import('@/views/ExaminResult.vue'),
  },
  {
    path: '/:plat_type/examinResultDetail',
    name: 'examinResultDetail',
    component: () => import('@/views/ExaminResultDetail.vue'),
  },
  {
    path: '/:plat_type/certSave',
    name: 'certSave',
    component: () => import('@/views/CertSave.vue'),
  },
  {
    path: '/:plat_type/certForm',
    name: 'certForm',
    component: () => import('@/views/CertForm.vue'),
  },
  {
    path: '/:plat_type/certList',
    name: 'certList',
    component: () => import('@/views/CertList.vue'),
  },
  {
    path: '/:plat_type/vip/chooseVIP',
    name: 'chooseVIP',
    component: () => import('@/views/vip/chooseVIP.vue'),
  },
  {
    path: '/:plat_type/vip/detailVIP',
    name: 'detailVIP',
    component: () => import('@/views/vip/DetailVIP.vue'),
  },
  {
    path: '/:plat_type/exchange',
    name: 'exchange',
    meta: {
      // requireAuth: true
    },
    component: () => import('@/views/Exchange.vue'),
  },
  {
    path: '/:plat_type/lessonYingyou',
    name: 'lesson',
    component: () => import('@/views/LessonYingyou.vue'),
  },
  {
    path: '/:plat_type/vipLesson',
    name: 'lesson',
    component: () => import('@/views/VipLesson.vue'),
  },
  {
    path: '/:plat_type/publicize',
    name: 'publicize',
    component: () => import('@/views/Publicize.vue'),
  },
  {
    path: '/:plat_type/publicizedetail/:id',
    name: 'publicizedetail',
    component: () => import('@/views/PublicizeDetail.vue'),
  },
  {
    path: "*",
    name: "404",
    redirct: "/404",
    component: () => import("@/views/NotFound.vue"),
    hidden: true
  }
]

const router = new VueRouter({
  scrollBehavior: (to, from, savedPosition) => {
    window.scrollTo(0, 0);
  },
  // mode: 'history',
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: baseRoutes
});

function is_weixin() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
}

router.beforeEach(async (to, from, next) => {
  NProgress.start();
  const token = localStorage.getItem('token');
  window.scrollTo(0, 0);
  if (token || !to.meta.requireAuth) {
    next()
    NProgress.done();
  } else {
    if (to.path.includes('/detailYingyou') && (to.query.id == 775 || to.query.id == 776)) {
      Dialog.confirm({
        title: '提示',
        message: '请登录后查看',
        confirmButtonText: '立即登录',
        showCancelButton: false
      })
        .then(() => {
          // on confirm
          window.localStorage.setItem('myUrl', window.location.href)
          next('/' + to.params.plat_type + '/login/phone?isXiaMen=1')
        })
    } else {
      Dialog.confirm({
        title: '提示',
        message: '请登录后查看',
        confirmButtonText: '立即登录',
      })
        .then(() => {
          // on confirm
          window.localStorage.setItem('myUrl', window.location.href)
          next('/' + to.params.plat_type + '/login/phone')
        })
        .catch(() => {
          next('/' + to.params.plat_type + '/index')
          // on cancel
        });
    }

    // next()
    NProgress.done();
  }
})

export default router
